
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgQuestionLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 17.333C4.397 17.333.667 13.603.667 9S4.397.667 9 .667A8.333 8.333 0 0 1 17.333 9 8.333 8.333 0 0 1 9 17.333zm0-1.666A6.667 6.667 0 1 0 9 2.333a6.667 6.667 0 0 0 0 13.334zM8.167 11.5h1.666v1.667H8.167V11.5zm1.666-1.37v.537H8.167v-1.25c0-.46.373-.834.833-.834a1.25 1.25 0 1 0-1.226-1.495L6.14 6.761a2.917 2.917 0 1 1 3.695 3.368z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\">\r\n            <g>\r\n                <g>\r\n                    <path d=\"M9 17.333C4.397 17.333.667 13.603.667 9S4.397.667 9 .667c4.602 0 8.333 3.73 8.333 8.333 0 4.602-3.73 8.333-8.333 8.333zm0-1.666c3.682 0 6.667-2.985 6.667-6.667S12.682 2.333 9 2.333 2.333 5.318 2.333 9 5.318 15.667 9 15.667zM8.167 11.5h1.666v1.667H8.167V11.5zm1.666-1.37v.537H8.167v-1.25c0-.46.373-.834.833-.834.658 0 1.204-.51 1.247-1.168.043-.657-.43-1.235-1.083-1.32-.653-.087-1.26.348-1.39.993L6.14 6.761c.28-1.402 1.535-2.394 2.963-2.343 1.429.05 2.61 1.127 2.792 2.545.181 1.418-.691 2.758-2.06 3.166z\" transform=\"translate(-57 -183) translate(17 169) translate(40 14)\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/question-line.a67de130abbda0d0fccdc51a728a4e10.svg"),
        {
          React: SvgQuestionLine,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      